// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--Bi3Pu","reload_button":"dd31006766--reload_button--Q_J9n","white":"dd31006766--white--HJUe8","black":"dd31006766--black--Wp5nA"};